package utils.tech

import csstype.PropertiesBuilder
import emotion.react.css
import react.FC
import react.Props
import react.ReactElement
import react.dom.html.HTMLAttributes
import react.dom.html.ReactHTML
import ru.malygin.myConst.UrlLocal
import ui.styles.Styles
import web.cssom.ClassName
import web.cssom.FontSize
import web.dom.Element
import web.window.WindowTarget
import web.window.window

class TextWithUrls(
    val mainText: String?,
    val urls: List<UrlLocal>,
    val cssPlus: (PropertiesBuilder) -> Unit = {},
    val cssPlusText: (PropertiesBuilder) -> Unit = {},
    val plusTextClass: ClassName = ClassName("adaptive_text_color"),
    val fontSize_: FontSize = FontSize.medium,//FontSize.xLarge
    val onClick: (url:String) -> Unit = {url:String ->
        window.open(url, WindowTarget._blank)
    },
) {


    fun giveMeText():FC<Props> {
        if (!checkNeedToRender()){
            return FC {
                ReactHTML.span {
                    className = plusTextClass
                    css(className) {
                        cssPlusText(this)
                        fontSize = fontSize_
                    }
                    +mainText
                }
            }
        }

        val render = renderLocal()

        val returnedFC = FC {
            render.map { renderOut->
                ReactHTML.div{
                    className = plusTextClass
                    css(className){
                        cssPlus(this)
                    }

                    renderOut.replaceUnit(
                        regularText = {
                            ReactHTML.span {
                                className = plusTextClass
                                css(className){
                                    cssPlusText(this)
                                    fontSize = fontSize_
                                }
                                +it
                            }
                        },
                        blockIfContain = {
                            ReactHTML.span{
                                className = ClassName(Styles.Buttons.linkText.toString() + " " + plusTextClass)
                                css(className){
                                    cssPlusText(this)
                                    fontSize = fontSize_
                                }

                                onClick = {_->
                                    onClick(urls.first{ uL-> uL.text == it }.url)
//                                    window.open(urls.first{ uL-> uL.text == it }.url, WindowTarget._blank)
                                }

                                +it
                            }
                        }
                    )
                }
            }
        }

        return returnedFC
    }

    private fun checkNeedToRender():Boolean{
        val mm = mutableListOf<Boolean>()
        urls.map {
            when{
                mainText.isNullOrEmpty() -> return false
                !mainText.contains(it.text) -> mm.add(false)
                else -> return true
            }
        }
        return mm.toList().distinct().contains(true)
    }

    private fun renderLocal(): List<String> {
        var newText = mainText!!

        urls.map { ul ->
            newText = newText.replace(ul.text, "[${ul.text}]")
        }

        val outputList = newText.split("]")
        return outputList
    }

    private fun String.replaceUnit(
        contain: String = "[",
        regularText:(String) -> Unit,
        blockIfContain:(String) -> Unit
    ) {
        val boolContain = this.contains(contain)

        regularText(this.split(contain).first())

        if (boolContain) {
            blockIfContain(this.split(contain).last())
        }
    }
}